import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdditionalColumnsPopup from './AdditionalColumnsPopup';
import { goPopup } from 'Store/actions/portalModalActions';

const mapDispatchToProps = (dispatch) => ({
  confirmChoise: () => {
    dispatch(goPopup(''));
  },
});

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  actions: dispatchProps,
}))(AdditionalColumnsPopup);
